import {get as _get} from 'lodash';

import validators from '@utils/validators';
import {TERRITORY_SELECTION_TYPE_WORLDWIDE} from '@constants/variables';

export const validate = (values, props) => {
    const errors = {};

    Object.assign(errors, validators.required(values.usages, 'usages'));
    Object.assign(errors, validators.required(values.territory_selection_type, 'territory_selection_type'));

    Object.assign(errors, validators.date(values.start_date, 'start_date'));
    Object.assign(errors, validators.date(values.end_date, 'end_date'));
    Object.assign(errors, validators.required(values.start_date, 'start_date'));
    Object.assign(errors, validators.required(values.end_date, 'end_date'));

    Object.assign(errors, validators.startDateBeforeEndDate({
        startDate: values.start_date,
        endDate: values.end_date,
    }, 'end_date'));

    if (TERRITORY_SELECTION_TYPE_WORLDWIDE !== parseInt(values.territory_selection_type)) {
        Object.assign(errors, validators.required(values.countries, 'countries'));
    }

    /**
     * SLA value required only when product is invoiceable and SLA toggle is switched on (_sla_enabled field).
     */
    const isInvoiceable = _get(props, 'GraphQLOptionsData.product.is_invoiceable', false);

    if (isInvoiceable && false === values._sla_enabled && null !== values._sla_enabled) {
        Object.assign(errors, validators.required(values.sla_minimum_threshold, 'sla_minimum_threshold'));
    }

    return errors;
};
